module.exports = __webpack_public_path__ + "static/media/ios_direction.9d78a4e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/ios_direction.svg
// module id = 369
// module chunks = 1